import { Link } from 'react-router-dom';
import { newsList } from '@/mocks/news';
import SectionHeading from '@/components/feature/SectionHeading';

export default function LatestNews() {
  const latest = [...newsList].sort((a, b) => (a.date < b.date ? 1 : -1)).slice(0, 5);

  return (
    <section className="container-page py-12 md:py-16">
      <SectionHeading
        eyebrow="News & Updates"
        title="最新动态精选"
        desc="作品消息、深度解读与人物专访，持续记录影视脉络。"
        actionTo="/news"
        actionLabel="查看全部动态"
      />
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <Link
          to={`/news/${latest[0].id}`}
          className="group relative overflow-hidden rounded-lg border border-background-200/70 cursor-pointer"
        >
          <div className="w-full overflow-hidden" style={{ aspectRatio: '16 / 10' }}>
            <img
              src={latest[0].cover}
              alt={latest[0].title}
              title={`${latest[0].title} - 影视动态`}
              className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-t from-primary-950/85 via-primary-950/30 to-transparent"></div>
          <div className="absolute bottom-0 left-0 w-full p-5 md:p-6">
            <span className="inline-block rounded-full bg-accent-500 px-2.5 py-0.5 text-[11px] font-medium text-primary-950">
              {latest[0].category}
            </span>
            <h3 className="mt-3 font-heading text-lg font-semibold text-background-50 md:text-xl">
              {latest[0].title}
            </h3>
            <p className="mt-2 text-sm text-background-200 line-clamp-2">{latest[0].summary}</p>
            <p className="mt-3 text-xs text-background-300">{latest[0].date}</p>
          </div>
        </Link>

        <ul className="flex flex-col divide-y divide-background-200/70 rounded-lg border border-background-200/70 bg-background-50">
          {latest.slice(1).map((item) => (
            <li key={item.id}>
              <Link
                to={`/news/${item.id}`}
                className="group flex items-start gap-4 p-5 transition-colors hover:bg-background-100 cursor-pointer"
              >
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                  <i className="ri-article-line text-xl" aria-hidden="true"></i>
                </span>
                <div className="min-w-0 flex-1">
                  <h4 className="font-medium text-foreground-950 line-clamp-2 group-hover:text-primary-700 transition-colors">
                    {item.title}
                  </h4>
                  <div className="mt-2 flex items-center gap-3 text-xs text-foreground-500">
                    <span className="text-accent-600">{item.category}</span>
                    <span className="h-1 w-1 rounded-full bg-foreground-300"></span>
                    <span>{item.date}</span>
                  </div>
                </div>
                <i className="ri-arrow-right-s-line mt-1 text-foreground-400 group-hover:text-primary-600 transition-colors" aria-hidden="true"></i>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}